import React from 'react';
import { useApp } from '../context/AppContext';
import './EventsTable.css';

const EventsTable = ({ expanded = false }) => {
  const { events, selectedEvent, setSelectedEvent, stats, selectedDisasterType } = useApp();

  // Filter events by selected disaster type
  const filteredEvents = events.filter(event => 
    selectedDisasterType === 'all' || event.disasterType === selectedDisasterType
  );

  const getDisasterIcon = (type) => {
    const icons = {
      wildfire: '🔥',
      flood: '🌊',
      drought: '🌵',
      windstorm: '💨'
    };
    return icons[type] || '📍';
  };

  const getStatusClass = (percentage) => {
    if (percentage >= 70) return 'severe';
    if (percentage >= 40) return 'moderate';
    return 'minor';
  };

  const getStatusLabel = (percentage) => {
    if (percentage >= 70) return 'Severe';
    if (percentage >= 40) return 'Moderate';
    return 'Minor';
  };

  const formatValue = (value) => {
    if (value >= 1000000) {
      return `R ${(value / 1000000).toFixed(1)}M`;
    } else if (value >= 1000) {
      return `R ${(value / 1000).toFixed(0)}k`;
    }
    return `R ${value.toLocaleString()}`;
  };

  return (
    <div className={`events-table ${expanded ? 'expanded' : ''}`}>
      <div className="table-header">
        <div className="table-title">
          <span className="table-icon">📊</span>
          <h3>Inventory Loss Dashboard</h3>
        </div>
        <div className="audit-badge">
          <span className="audit-icon">🛡️</span>
          <span>Financial Compliance of Geoventory data is audited by <strong>AEGLai</strong> (Auditive Engine Generative Ledger Artificial Intelligence).</span>
        </div>
      </div>

      <div className="table-container">
        <table>
          <thead>
            <tr>
              <th>Erf Number</th>
              <th>Disaster Type</th>
              <th>Event Date</th>
              <th>Commodity</th>
              <th>Before</th>
              <th>Current</th>
              <th>Loss %</th>
              <th>Value Before</th>
              <th>Current Value</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {filteredEvents.map((event) => (
              <tr 
                key={event._id}
                className={selectedEvent?._id === event._id ? 'selected' : ''}
                onClick={() => setSelectedEvent(event)}
              >
                <td className="erf-cell">{event.erfNumber || 'N/A'}</td>
                <td className="disaster-cell">
                  <span className="disaster-icon">{getDisasterIcon(event.disasterType)}</span>
                  <span className="disaster-name">
                    {event.disasterType ? event.disasterType.charAt(0).toUpperCase() + event.disasterType.slice(1) : 'Unknown'}
                  </span>
                </td>
                <td>{event.eventDate ? new Date(event.eventDate).toLocaleDateString() : 'N/A'}</td>
                <td>{event.commodity?.name || 'N/A'}</td>
                <td>{(event.quantityBefore || 0).toLocaleString()} {event.commodity?.unit || ''}</td>
                <td>{(event.quantityCurrent || 0).toLocaleString()} {event.commodity?.unit || ''}</td>
                <td className="loss-cell">
                  <span className={`loss-badge ${getStatusClass(event.lossPercentage || 0)}`}>
                    -{event.lossPercentage || 0}%
                  </span>
                </td>
                <td>{formatValue(event.valueBefore || 0)}</td>
                <td>{formatValue(event.valueCurrent || 0)}</td>
                <td>
                  <span className={`status-badge ${getStatusClass(event.lossPercentage || 0)}`}>
                    {getStatusLabel(event.lossPercentage || 0)}
                  </span>
                </td>
              </tr>
            ))}
            {filteredEvents.length === 0 && (
              <tr>
                <td colSpan="10" className="no-data">No events found for the selected disaster type.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <div className="table-stats">
        <div className="stat-card">
          <span className="stat-label">Total Events</span>
          <span className="stat-value">{stats.totalEvents || events.length}</span>
        </div>
        <div className="stat-card">
          <span className="stat-label">Avg Loss %</span>
          <span className="stat-value">{Math.round(stats.avgLossPercentage || 0)}%</span>
        </div>
        <div className="stat-card">
          <span className="stat-label">Total Value Loss</span>
          <span className="stat-value danger">{formatValue(stats.totalValueLoss || 0)}</span>
        </div>
        <div className="stat-card">
          <span className="stat-label">Insurance Claims</span>
          <span className="stat-value">{stats.totalClaims || 0}</span>
        </div>
      </div>
    </div>
  );
};

export default EventsTable;
